module.exports = __webpack_public_path__ + "img/1553124251.79e96299.jpg";